import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdaptiveaccessDashboardService } from './dashboard.service';
import { AdaptiveAccessChart, AdaptiveAccessDashboard, AdaptiveAccessReport, Header } from '@aptsi-types';
import { AdaptiveAccessReportService } from '../reports/reports.service';
@Component({
  selector: 'app-auth-tool-home',
  templateUrl: './auth-tool-home.component.html',
  styleUrls: ['./auth-tool-home.component.scss']
})
export class AuthToolHomeComponent {

  constructor(private router: Router,
    private adaptiveAccessDashboardService: AdaptiveaccessDashboardService,
    private adaptiveAccessReportService:AdaptiveAccessReportService,
    private route:ActivatedRoute
  ) { }

  data: AdaptiveAccessDashboard = null;

  chartdata: AdaptiveAccessChart[] = [];

  reportdata: AdaptiveAccessReport[] = [];

  selectedFilter: string = 'all_time';

  headers: Header[] = [
    {
      name: "Asset Name",
      property: "assetname",
      showInDropdown: true,

    },
    {
      name: "Risk Score",
      property: "riskscore",
      showInDropdown: true,

    },
    {
      name: "Access Threshold",
      property: "accessthreshold",
      showInDropdown: true,

    },
    {
      name: "Access Type",
      property: "accesstype",
      showInDropdown: true,

    },

  ]

  // async ngOnInit(): Promise<void> {

  //   this.fetchDashboardData();
  //   this.fetchDashboardChartData();
  //   this.fetchReportData();
    
  // }

     ngOnInit(): void {
    const resolved = this.route.snapshot.data['dashboard'];

    this.data = resolved.dashBoardData;
    this.reportdata = resolved.data["recentAccessControls"] || [];
    this.chartdata = resolved.chartdata["recentAccessControls"] || [];

    // Setup chartData
    this.chartdata.forEach(item => console.log("Parsed Date:", new Date(item.timestamp).toISOString()));
  
      // Update the chartData object dynamically after fetching data
      this.chartData = {
        labels: this.chartdata.map(item => 
          new Date(item.timestamp).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
          }) // Example: "Mar 23, 2025"
        ), 
        datasets: [
          {
            label: 'Risk Score',
            data: this.chartdata.map(item => item.riskscore),
            borderColor: 'rgba(75,192,192,1)',
            backgroundColor: 'rgba(75,192,192,0.2)',
            borderWidth: 2,
            fill: false,
            tension: 0.3
          },
          {
            label: 'Threshold',
            data: this.chartdata.map(item => item.accessthreshold),
            borderColor: 'rgba(255,99,132,1)',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderWidth: 2,
            fill: false,
            tension: 0.3,
            borderDash: [5, 5]
          }
        ]
    };
  }



chartData: any = {
    labels: [],
    datasets: []
  };


  
  
  // Chart options to customize tooltips and X-axis labels
  chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'
      },
      tooltip: {
        enabled: true,
        callbacks: {
          title: (tooltipItems) => {
            const index = tooltipItems[0].dataIndex;
            return new Date(this.chartdata[index].timestamp).toLocaleString('en-US', { 
              year: 'numeric', 
              month: 'short', 
              day: 'numeric', 
              hour: '2-digit', 
              minute: '2-digit', 
              second: '2-digit', 
              hour12: true 
            }); // Show full timestamp on hover
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Date'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Risk Score'
        },
        min: 0,
        max: 100
      }
    }
  };
  

}
